<div *ngIf="!title" class="cropper-heading" transloco="imageCropper.heading">Crop Image</div>
<div *ngIf="title" class="cropper-heading">{{title}}</div>
<div class="container"
     [ngStyle]="{height: imageFrameHeight + 'px', width: imageFrameWidth + 'px'}">

     <div class="image-cropper-row">
      <div class="reload-btn-alignment">
      <!-- Cancel Button -->
        <img class="confirm-crop-image" aeroTooltip="{{'imageCropper.cancel' | transloco}}"
              (click)="cancel()" [src]="'resources/images/cancel_crop_icon.svg'" />

      <!-- Rotate Button -->
      <img *ngIf="enableRotate" class="confirm-crop-image" [src]="'resources/images/rotate_icon.svg'"
              (click)="rotate()" aeroTooltip="{{'imageCropper.rotate' | transloco}}"/>

      <!-- Save Button -->
        <img class="confirm-crop-image" [src]="'resources/images/confirm_crop_icon.svg'"
              (click)="cropped()" aeroTooltip="{{'imageCropper.crop' | transloco}}"/>
      </div>
    </div>

  <angular-cropper
    [imageUrl]="imageUrl"
    [cropperOptions]="config"
    (ready)="imageLoaded()"
    #angularCropper></angular-cropper>
</div>
